module.exports = __webpack_public_path__ + "static/media/5.280329d5.png";